module.exports = __webpack_public_path__ + "static/media/card-worker-icon.b5b696b0.svg";